import { useEffect, useState } from 'react';
import { CheckoutRenderer } from '../checkout/renderer';
import type { PublicCheckout } from '../checkout/contract';
import '../checkout/checkout.css';

const INBOUND = 'vp-preview';
const READY = 'vp-preview-ready';

export function PreviewFrame() {
  const [checkout, setCheckout] = useState<PublicCheckout | null>(null);

  useEffect(() => {
    function onMessage(event: MessageEvent) {
      const data = event.data as { type?: string; checkout?: PublicCheckout } | null;
      if (!data || data.type !== INBOUND || !data.checkout) return;
      setCheckout(data.checkout);
    }
    window.addEventListener('message', onMessage);
    window.parent?.postMessage({ type: READY }, '*');
    return () => window.removeEventListener('message', onMessage);
  }, []);

  if (!checkout) {
    return (
      <div className="vp-root vp-state">
        <p className="vp-faint">Configure o checkout ao lado para ver a pré-visualização.</p>
      </div>
    );
  }

  return <CheckoutRenderer checkout={checkout} preview />;
}
